import React from 'react';
import { ActivityLog } from '../types';
import { Activity, X, ShieldAlert } from 'lucide-react';

interface ActivityLogViewProps {
  logs: ActivityLog[];
  onClose?: () => void;
}

export const ActivityLogView: React.FC<ActivityLogViewProps> = ({ logs, onClose }) => {
  return (
    <div className="bg-slate-900 border border-slate-800 rounded-3xl p-5 space-y-4 shadow-2xl">
      <div className="flex justify-between items-center border-b border-slate-800 pb-3">
        <div className="flex items-center gap-2">
          <Activity className="w-5 h-5 text-emerald-400" />
          <h3 className="font-extrabold text-base text-white">Organizer Activity & Audit Log</h3>
        </div>
        {onClose && (
          <button onClick={onClose} className="p-1 rounded-xl bg-slate-800 text-slate-400 hover:text-white">
            <X className="w-4 h-4" />
          </button>
        )}
      </div>

      <div className="space-y-2 max-h-96 overflow-y-auto pr-1">
        {logs.map((log) => (
          <div key={log.id} className="bg-slate-950 p-3 rounded-2xl border border-slate-800 text-xs space-y-1">
            <div className="flex justify-between items-center font-bold">
              <span className="text-emerald-400">{log.actorName} • {log.action}</span>
              <span className="text-[10px] text-slate-500 font-mono">{log.timestamp}</span>
            </div>
            <p className="text-slate-300">{log.details}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
